"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function toArray(obj) {
  var array = []; // iterate backwards ensuring that length is an UInt32

  for (var i = obj.length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}

var _default = {
  toArray: toArray
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-drag-and-drop/lib/utils.js
// module id = 8988
// module chunks = 2